// extracted by mini-css-extract-plugin
export default {"badge":"RMSBadge_badge__WKXe6"};